import React, { useState, useEffect, Fragment, useMemo, useCallback, useRef } from "react";
import { Row, Card, Col, Label, Input, Table } from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import AlertError from "../../../components/Alerts/AlertError";
import Select from "react-select";
import {
  getOrgsAdmin as onGetOrgsAdmin,
  getEmployeesAdmin,
  postEmployeesAdminCreateAddress,
  getServiceRequestAdmin,
  patchUpdateRequest,
  postPreRequestService
} from "../../../helpers/api_rombo_helper";
import PopupSuccess from "../../../components/Popups/PopupSuccess";
import MapServices from "../../Google/MapServices";
import { map, chunk, debounce } from "lodash";
import config from "../../../constants/settings";
import { BookingType, VisibilityTypes, TypeAddress, EmployeeStatus } from "../../../constants/enums";
import { orgId, isPartnerAllowed } from "../../../constants/utils";
import { allowedHoursOptions } from "../../../constants/utils";

const PreRequestService = (props) => {
  document.title = `${i18n.t("ServiceRequest")} - ${orgId}`;

  const dispatch = useDispatch();
  const history = useNavigate();
  const overnightHours = ["00:10", "00:30", "01:10", "01:30", "02:10", "02:30"];
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [listCompanies, setListCompanies] = useState([]);
  const [minTime, setMinTime] = useState("");
  const [key, setKey] = useState(0);
  const [isFirstCompanySelection, setIsFirstCompanySelection] = useState(true);
  const [listTypeService, setListTypeService] = useState([]);
  const [company, setCompany] = useState({});
  const [typeService, setTypeService] = useState({ id: "DESAFORO", label: i18n.t("Desaforo"), value: "DESAFORO", metaValue: BookingType.CLOSED  });
  const [showCompany, setShowCompany] = useState(true);
  const [showGeneral, setShowGeneral] = useState(false);
  const [showDateHour, setShowDateHour] = useState(false);
  const [showTypeService, setShowTypeService] = useState(false);
  const [showAdditionalNote, setShowAdditionalNote] = useState(false);
  const [showAddresses, setShowAddresses] = useState(false);
  const [showUnits, setShowUnits] = useState(false);
  const [showIdTag, setShowIdTag] = useState(false);
  const [showEmployees, setShowEmployees] = useState(false);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [showScales, setShowScales] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [onFocusAddress, setOnFocusAddress] = useState("");
  const [newCreateAddressEmployee, setNewCreateAddressEmployee] = useState({});
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [formatEmployees, setFormatEmployees] = useState([]);
  const [arrScales, setArrScales] = useState([{ id: 3, latLon: false, typeAddress: TypeAddress.ARRAY_SCALES, dragg: false, editRow: false, onDrag: false, passenger_id: null, name: null, address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } }]);
  const [opts, setOpts] = useState({});
  const [aditionalNote, setAditionalNote] = useState("");
  const [idTag, setIdTag] = useState("");
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedServiceOption, setSelectedServiceOption] = useState(null);
  const [showSelect, setShowSelect] = useState(false);
  const [showNextBlock, setShowNextBlock] = useState(false);
  const [disableTextarea, setDisableTextarea] = useState(false);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestiny, setSelectedDestiny] = useState(null);
  const [originAddressService, setOriginAddressService] = useState({});
  const [destinyAddressService, setDestinyAddressService] = useState({});
  const [addressesMarkers, setAddressesMarkers] = useState([]);
  const [units, setUnits] = useState(1);
  const [selectedUnitOption, setSelectedUnitOption] = useState(null);
  const [titleAdressDestiny, setNameTitleDestiny] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: "" }));
  const [titleAdressOrigin, setNameTitleOrigin] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: "" }));
  const [titleAdressArrScales, setNameTitleArrScales] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Employee"), address: "" }));
  const [titleAdressArrEmployees, setNameTitleEmployees] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Scale"), address: "" }));
  const [employees, setEmployees] = useState([]);
  const [employeesSelectedFind, setEmployeesSelectedFind] = useState([]);
  const [employeesSelected, setEmployeesSelected] = useState([]);
  const [findEmployees, setFindEmployees] = useState([]);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [validationsAddresses, setValidationsAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [serviceCode, setServiceCode] = useState(null);
  const [isPastDeadline, setIsPastDeadline] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const [autoAddedEmployeeId, setAutoAddedEmployeeId] = useState(null);
  const [hasEmployeeScale, setHasEmployeeScale] = useState(false);
  const [currentService, setCurrentService] = useState(null);
  const [employeeConfirmed, setEmployeeConfirmed] = useState(false);
  const [employeeAddresses, setEmployeeAddresses] = useState([]);
  const [employeeHasMultipleAddresses, setEmployeeHasMultipleAddresses] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [errors, setErrors] = useState({
    origin: false,
    destiny: false,
    company: false,
    date: false,
    hour: false,
    typeService: false,
  });

  const [hourService, setHourService] = useState("");
  const [dateService, setDateService] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
      userProfile: Login.userProfile
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  const userProfile = {
    username: data?.data?.full_name || '',
    sub: data?.data?.id || ''
  };

  const setError = (field, value) => {
    setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: value,
    }));
  };

  useEffect(() => {
    fillTypeService();
    getMinutes();
    infoUser.is_staff ? getCompanies() : fillCompany();
    if (!infoUser.is_staff) {
      setShowGeneral(true);
    }

    checkDeadline();
  }, [dispatch, infoUser]);
  
  useEffect(() => {
    if (company?.value !== undefined) {
      onGetEmployeesAdmin();
    }
  }, [dispatch, company]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data);
      if (!data.data.is_staff) {
        setShowGeneral(true);
        setShowCompany(false);
      }
    }
  }, [data, loading]);

  useEffect(() => {
    fEmployee();
  }, [employeesSelected]);

  useEffect(() => {
    if (editingEmployee?.addresses?.length > 0) {
      setSelectedAddress(editingEmployee.addresses[0].id);
    }
  }, [editingEmployee]);

  useEffect(() => {
    const now = new Date();
    const today = new Date();
  
    const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    
    if (dateService === todayStr) {
      now.setMinutes(now.getMinutes() + 25);
      const minHours = now.getHours().toString().padStart(2, '0');
      const minMinutes = now.getMinutes().toString().padStart(2, '0');
      const minTimeFormatted = `${minHours}:${minMinutes}`;
      
      setMinTime(minTimeFormatted);
  
      if (!overnightHours.includes(hourService)) {
        const [currentHour, currentMinute] = hourService.split(':').map(Number);
        const minTimeInMinutes = parseInt(minHours) * 60 + parseInt(minMinutes);
        const currentTimeInMinutes = currentHour * 60 + currentMinute;
        
        if (currentTimeInMinutes < minTimeInMinutes) {
          setHourService(minTimeFormatted);
        }
      }
    } else {
      setMinTime("");

      if (overnightHours.includes(hourService)) {
        return;
      }
    }
  }, [dateService, hourService]); 

  useEffect(() => {
    fillTypeService();
  }, []);
  
  useEffect(() => {
    fillTypeService();
    setTypeService(prev => ({
      ...prev,
      label: i18n.t("Desaforo")
    }));
  }, [i18n]);

  useEffect(() => {
    validateAddresses();
  }, [originAddressService.description, destinyAddressService.description, typeService.value]);

  useEffect(() => {
    if (company?.value) {
      setErrors(prev => ({ ...prev, company: false }));
    }
  }, [company]);  

  useEffect(() => {
    if (company?.value) {
      setErrors(prev => ({ ...prev, company: false }));
    }
  }, [company]);

  useEffect(() => {
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    setDateService(todayStr);
  }, []);
  
  useEffect(() => {
    if (hourService && overnightHours.includes(hourService)) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const tomorrowStr = `${tomorrow.getFullYear()}-${(tomorrow.getMonth() + 1).toString().padStart(2, '0')}-${tomorrow.getDate().toString().padStart(2, '0')}`;
      setDateService(tomorrowStr);
    }
  }, [hourService]);

  const fEmployee = () => {
    let arr = []
    employeesSelected.map((item) => {
      arr.push({ label: item.name, value: item.idEmployee })
    })
    setFormatEmployees([...arr])
  }

  const getMinutes = (selectedDate) => {
    const minTimeSlots = parseInt(config.services.timeSlots, 10) + 5;
    const now = new Date();
    const date = new Date(selectedDate);
  
    if (isNaN(date.getTime())) {
      console.error('Fecha seleccionada inválida');
      return;
    }
  
    const isToday = now.toDateString() === date.toDateString();
  
    if (isToday) {
      now.setMinutes(now.getMinutes() + minTimeSlots);
      const minHours = now.getHours().toString().padStart(2, '0');
      const minMinutes = now.getMinutes().toString().padStart(2, '0');
      const minTimeFormatted = `${minHours}:${minMinutes}`;
      setMinTime(minTimeFormatted);
      setHourService(minTimeFormatted);
    } else {
      setMinTime("00:00");
      setHourService("00:00");
    }
  };  

  useEffect(() => {
    if(!newCreateAddressEmployee.idDB) return;

    let body = { addresses: [{ name: "Default", address: { ...newCreateAddressEmployee } }]}
    postEmployeesAdminCreateAddress(token, newCreateAddressEmployee.idDB, body)
      .then((responseAddress) => {
        onGetEmployeesAdmin()
      })
      .catch((error) => { 
        console.error("Error - postEmployeesAdminCreateAddress - ", error)
        if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
      })  
    
  }, [newCreateAddressEmployee]);

  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      fetchServiceRequest(id);
    }
  }, [id]);

  useEffect(() => {
    if (isEditMode) {
      setShowNextBlock(true);
    }
  }, [isEditMode]);
  
  useEffect(() => {
    if (showEmployees && isEditMode && company.value) {
      const initialOpts = { 
        partner_id: company.value, 
        size: 5, 
        status: EmployeeStatus.ACTIVE,
        page: 1
      };
      onGetEmployeesAdmin(initialOpts);
      
      if (employeesSelectedFind.length > 0) {
        const selectedIds = employeesSelectedFind.map(e => e.idEmployee);
        setFindEmployees(prev => prev.filter(emp => !selectedIds.includes(emp.id)));
      }
    }
  }, [showEmployees, isEditMode, company.value, employeesSelectedFind]);
  
  const fetchServiceRequest = async (requestId) => {
    try {
      const response = await getServiceRequestAdmin(token, requestId);
      const data = response || {};
      setCurrentService(data);
  
      setTypeService({
        label:
          data.type === BookingType.OPEN
            ? i18n.t("TextService1")
            : data.type === BookingType.CLOSED
            ? i18n.t("TextService2")
            : data.type || "N/A",
        value: data.type || "",
      });
      setCompany({ label: data.partner_name || "N/A", value: data.partner_id || "" });
      setDateService(data.scheduled_start?.date || "");
      setHourService(data.scheduled_start?.time || "");
      setAditionalNote(data.info?.notes?.[0]?.message || "");
      setIdTag(data.info?.cost_center?.name || "");
  
      const markers = [];
  
      const normalizeLocation = (latlng) => {
        return {
          lat: Number(latlng.latitude),
          lng: Number(latlng.longitude ?? latlng.lon ?? latlng.lng),
        };
      };
  
      const origin = data.info?.origin?.address;
      if (origin) {
        const originData = {
          id: TypeAddress.ORIGIN,
          description: origin.description,
          location: normalizeLocation(origin.latlng),
          typeAddress: TypeAddress.ORIGIN,
          dragg: true,
        };
        setOriginAddressService(originData);
        setSelectedOrigin(originData.location);
        markers.push(originData);
      }
  
      const destination = data.info?.destination?.address;
      if (destination) {
        const destinationData = {
          id: TypeAddress.DESTINY,
          description: destination.description,
          location: normalizeLocation(destination.latlng),
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
        };
        setDestinyAddressService(destinationData);
        setSelectedDestiny(destinationData.location);
        markers.push(destinationData);
      }
  
      const scales = data.info?.scales || [];
      const formattedScales = scales.map((scale, index) => ({
        id: index + 1,
        description: scale.address.description,
        location: normalizeLocation(scale.address.latlng),
        typeAddress: TypeAddress.ARRAY_SCALES,
        dragg: true,
        order: scale.order || index + 1,
      }));
      setArrScales(formattedScales);
      markers.push(...formattedScales);
  
      const riders = data.info?.riders || [];
      const formattedEmployees = riders.map((rider) => {
        const employeeInfo = findEmployees.find((emp) => emp.id === rider.id) || {};
  
        return {
          idEmployee: rider.id,
          id: rider.id,
          name: rider.name,
          identifier: employeeInfo.identifier || "N/A",
          depot: employeeInfo.depot || "N/A",
          addresses: employeeInfo.addresses || [],
          available_trips: employeeInfo.available_trips || 0,
          cost_center: employeeInfo.cost_center || { name: "N/A" },
          dropoff: rider.dropoff,
          address: employeeInfo.addresses?.[0] || {},
          is_individual_trip: false,
        };
      });
  
      setEmployeesSelectedFind(formattedEmployees);
      setEmployeesSelected(formattedEmployees);
      setAddressesMarkers(markers);
  
      if (riders.length > 0) {
        const employeeIds = riders.map((r) => r.id);
        getEmployeesAdmin(token, { ids: employeeIds.join(",") })
          .then((response) => {
            setFindEmployees(response.items);
          })
          .catch((error) => {
            console.error("Error fetching employees details:", error);
          });
      }
  
      riders.forEach((rider) => {
        if (!rider.dropoff.destination) {
          const scaleIndex = rider.dropoff.scale_order - 1;
          if (scaleIndex >= 0 && scaleIndex < formattedScales.length) {
            formattedScales[scaleIndex].employeeId = rider.id;
            formattedScales[scaleIndex].employeeName = rider.name;
          }
        }
      });
    } catch (error) {
      console.error("Error getting service request:", error);
      setErrorAlert(true);
      setErrorAlertMessage(error?.response?.data?.detail || error.message);
    }
  };

  const onClickUpdateRequest = () => {
    if (!typeService.value) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    if (
      (!originAddressService?.location && typeService.value !== BookingType.ARRIVAL) ||
      (!destinyAddressService?.location && typeService.value === BookingType.CLOSED)
    ) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    const normalizeLatLng = (location) => {
      if (!location) return null;
      const lat = Number(location?.lat ?? location?.latitude);
      const lon = Number(location?.lon ?? location?.lng ?? location?.longitude);
      if (isNaN(lat) || isNaN(lon)) return null;
      return { latitude: lat, longitude: lon };
    };
  
    const patchPayload = {
      code: id.toString(),
      info: {
        origin: {
          address: {
            description: originAddressService.description,
            latlng: normalizeLatLng(originAddressService.location),
          },
        },
        ...(typeService.value === BookingType.CLOSED && {
          destination: {
            address: {
              description: destinyAddressService.description,
              latlng: normalizeLatLng(destinyAddressService.location),
            },
          },
          ...(arrScales.length > 0 && {
            scales: arrScales
              .map((scale, index) => {
                const latlng = normalizeLatLng(scale.location);
                if (!scale.description || !latlng) return null;
                return {
                  order: index + 1,
                  address: {
                    description: scale.description,
                    latlng,
                  },
                };
              })
              .filter(Boolean),
          }),
        }),
        riders: employeesSelected.map((employee) => {
          const baseRider = {
            id: employee.idEmployee,
            name: employee.name,
            cost_center_id: employee.cost_center?.id || "",
            cost_center_name: employee.cost_center_name || "",
            dropoff: {
              destination: employee.dropoff.destination ?? true,
              scale_order: employee.dropoff.scale_order ?? 0,
            },
          };
  
          if (
            typeService.value !== BookingType.CLOSED &&
            typeService.value !== BookingType.OPEN
          ) {
            return {
              ...baseRider,
              is_individual_trip: employee.is_individual_trip,
              address: {
                description:
                  employee.address?.address?.description ??
                  employee.address?.description ??
                  "",
                latlng: normalizeLatLng(
                  employee.address?.address?.location ??
                    employee.address?.location ??
                    null
                ),
              },
            };
          }
  
          return baseRider;
        }),
        ...(aditionalNote && {
          notes: [{ message: aditionalNote }],
        }),
        ...(idTag.trim() !== "" && {
          cost_center: {
            id: "",
            name: idTag.trim(),
          },
        }),
      },
    };
  
    if (patchPayload.info.riders.length === 0) {
      setErrorAlertMessage(i18n.t("AtLeastOneEmployeeRequired"));
      setErrorAlert(true);
      return;
    }
  
    if (typeService.value === BookingType.CLOSED && patchPayload.info.scales) {
      const invalidScales = patchPayload.info.scales.filter(
        (scale) =>
          !scale.address?.description ||
          !scale.address?.latlng ||
          isNaN(scale.address.latlng.latitude) ||
          isNaN(scale.address.latlng.longitude)
      );
  
      if (invalidScales.length > 0) {
        console.error("Invalid scales detected:", invalidScales);
        setErrorAlertMessage(i18n.t("InvalidScaleAddresses"));
        setErrorAlert(true);
        return;
      }
    }
  
    serviceEdit(patchPayload);
  };  

  const onClickCreateRequest = async () => {
    if (checkDeadline()) {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }
  
    if (isSubmittingRef.current) {
        return;
    }
    
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    
    if (!typeService.metaValue) {
        setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
        setErrorAlert(true);
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        return;
    }

    if ((!originAddressService?.location && typeService.metaValue !== BookingType.ARRIVAL) || 
        (!destinyAddressService?.location && typeService.metaValue === BookingType.CLOSED)) {
        setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
        setErrorAlert(true);
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        return;
    }
  
    try {
        for (let unitIndex = 0; unitIndex < units; unitIndex++) {
            const unitEmployees = groupedEmployees[unitIndex] || [];
  
            const arr = [];
            let scaleCounter = 1;
  
            unitEmployees.forEach((item) => {
                let body = {
                    id: item.idEmployee,
                    name: item.name,
                    cost_center_id: item.cost_center_id ?? "N/A",
                    cost_center_name: item.cost_center_name ?? "N/A",
                    dropoff: {
                        destination: true,
                        scale_order: 0,
                    },
                };
  
                arrScales.forEach((scale) => {
                    if (scale.location && item.idEmployee === (scale.employeeId || scale.passenger_id)) {
                        body.dropoff.destination = false;
                        body.dropoff.scale_order = scaleCounter;
                        scaleCounter++;
                    }
                });
  
                if (typeService.metaValue !== BookingType.CLOSED && typeService.metaValue !== BookingType.OPEN) {
                    body.is_individual_trip = item.is_individual_trip;
                    body.address = {
                        description: item.address.address.description,
                        latlng: {
                            latitude: item.address.address.location.lat,
                            longitude: item.address.address.location.lon,
                        },
                    };
                }
                arr.push(body);
            });
  
            let formData = bodyGral();
            formData.info.riders = arr;
            formData.type = typeService.metaValue;
            formData.info.unit_number = unitIndex + 1;
  
            switch (typeService.metaValue) {
                case BookingType.OPEN:
                    formData.info.origin = {
                        address: {
                            description: originAddressService.description.toString(),
                            latlng: {
                                latitude: originAddressService.location.lat,
                                longitude: originAddressService.location.lon,
                            },
                        },
                    };
                    break;
  
                case BookingType.CLOSED:
                    const onArrScales = arrScales
                        .filter(scale =>
                            scale.location &&
                            (unitEmployees.some(e => e.idEmployee === (scale.employeeId || scale.passenger_id)) || !scale.employeeId)
                        )
                        .map((scale, index) => ({
                            order: index + 1,
                            address: {
                                description: scale.description,
                                latlng: {
                                    latitude: scale.location.lat,
                                    longitude: scale.location.lon || scale.location.lng,
                                },
                            },
                        }));
                    formData.info.scales = onArrScales;
                    formData.info.origin = {
                        address: {
                            description: originAddressService.description,
                            latlng: {
                                latitude: originAddressService.location.lat,
                                longitude: originAddressService.location.lon || originAddressService.location.lng,
                            },
                        },
                    };
                    formData.info.destination = {
                        address: {
                            description: destinyAddressService.description,
                            latlng: {
                                latitude: destinyAddressService.location.lat,
                                longitude: destinyAddressService.location.lon || destinyAddressService.location.lng,
                            },
                        },
                    };
                    break;
  
                case BookingType.ARRIVAL:
                    formData.info.destination = {
                        address: {
                            description: destinyAddressService.description.toString(),
                            latlng: {
                                latitude: destinyAddressService.location.lat,
                                longitude: destinyAddressService.location.lon,
                            },
                        },
                    };
                    break;
  
                case BookingType.LEAVING:
                    formData.info.origin = {
                        address: {
                            description: originAddressService.description.toString(),
                            latlng: {
                                latitude: originAddressService.location.lat,
                                longitude: originAddressService.location.lon,
                            },
                        },
                    };
                    break;
            }

            await serviceCreate(formData);
        }
      } catch (error) {
        console.error("Error creating requests:", error);
      
        const errorCode =
          error?.response?.data?.error?.extensions?.code ||
          error?.extensions?.code;
      
        const errorMessage =
          error?.response?.data?.error?.message ||
          error?.message;
      
        if (
          errorCode === 409 &&
          errorMessage === "The employee is already in pre-request"
        ) {
          setErrorAlertMessage(
            i18n.t("EmployeeAlreadyHasPreRequestToday")
          );
        } else {
          setErrorAlertMessage(i18n.t("InvalidServiceType"));
        }
      
        setErrorAlert(true);
      } finally {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
      }      
  };

  const bodyGral = () => {
    const body = {
      company_id: company.value.toString(),
      scheduled_start: {
        timezone: "America/Mexico_City",
        date: dateService,
        time: hourService,
      },
      info: {},
    };
    if (aditionalNote) {
      body.info.notes = [{ message: aditionalNote }];
    }
  
    if (!disableTextarea && idTag.trim() !== "") {
      body.info.cost_center = {
        id: "",
        name: idTag.trim(),
      };
    }
  
    if (filteredEmployees.length > 0) {
      const requester = filteredEmployees[0];
      body.info.requested_by = {
        id: requester.id,
        name: requester.name,
      };
    }
  
    if (userProfile.username && userProfile.sub) {
      body.info.action_by = {
        id: userProfile.sub,
        name: userProfile.username,
      };
    }
  
    return body;
  };

  const predefinedOriginOptions = [
    {
      value: "norte_45_847",
      label: "Norte 45 847",
      description: "Norte 45 847",
      location: {
        lat: 19.490304693168373,
        lng: -99.15997037524792
      },
      latlng: {
        latitude: "19.490304693168373",
        longitude: "-99.15997037524792"
      }
    },
    {
      value: "poniente_128_550",
      label: "Poniente 128 No. 550",
      description: "Poniente 128 No. 550",
      location: {
        lat: 19.49014770539018,
        lng: -99.15866830137416
      },
      latlng: {
        latitude: "19.49014770539018",
        longitude: "-99.15866830137416"
      }
    },
    {
      value: "calzada_vallejo_1849",
      label: "Calzada Vallejo No. 1849",
      description: "Calzada Vallejo No. 1849",
      location: {
        lat: 19.52773603231045,
        lng: -99.1692102603386
      },
      latlng: {
        latitude: "19.52773603231045",
        longitude: "-99.1692102603386"
      }
    }
  ];

  const handleOriginSelect = (selectedOption) => {
    if (selectedOption) {
      const selectedAddress = {
        description: selectedOption.description,
        location: selectedOption.location,
        latlng: selectedOption.latlng,
        typeAddress: TypeAddress.ORIGIN,
        dragg: false
      };
  
      setOriginAddressService(selectedAddress);
      setSelectedOrigin(selectedOption.location);
      setErrors(prev => ({...prev, origin: false}));
  
      const updatedMarkers = addressesMarkers.filter(marker => 
        marker.typeAddress !== TypeAddress.ORIGIN
      );
      
      updatedMarkers.push({
        ...selectedAddress,
        id: TypeAddress.ORIGIN
      });
      
      setAddressesMarkers(updatedMarkers);
  
      if (destinyAddressService?.location) {
        setTimeout(() => {
          calculateRoute(selectedOption.location, destinyAddressService.location, arrScales);
        }, 100);
      }
    } else {
      setOriginAddressService({});
      setSelectedOrigin(null);
      
      const updatedMarkers = addressesMarkers.filter(marker => 
        marker.typeAddress !== TypeAddress.ORIGIN
      );
      setAddressesMarkers(updatedMarkers);
    }
  };

  const onGetEmployeesAdmin = (newOpts = { page: 1, service: true, size: 5, partner_id: company.value, status: EmployeeStatus.ACTIVE }) => {
    setLoading(true);
    getEmployeesAdmin(token, newOpts)
      .then((response) => {
        setOpts(newOpts);
        setEmployees(response);
        
        const selectedIds = employeesSelectedFind.map(e => e.idEmployee);
        const filteredItems = response.items.filter(emp => !selectedIds.includes(emp.id));
        
        setFindEmployees(filteredItems);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - getEmployeesAdmin - ", error);
        setLoading(false);
      });
  };

  const getCompanies = () => {
    let arr = []
    onGetOrgsAdmin()
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const groupedEmployees = chunk(employeesSelectedFind, 4);

  const onClickAddEmployees = (employee, isAutomaticSelection = false, isSingleUnitForMe = false) => {
    let updatedEmployeesSelected = [...employeesSelected];
    let updatedValidationsAddresses = [...validationsAddresses];
    let updatedFindEmployees = [...findEmployees];
    let updatedArrScales = [...arrScales];
    let updatedAddressesMarkers = [...addressesMarkers];
  
    const existingEmployee = updatedEmployeesSelected.find(
      (opt) => opt.idEmployee === employee.id
    );
  
    if (existingEmployee && !isAutomaticSelection) {
      updatedEmployeesSelected = updatedEmployeesSelected.filter(
        (opt) => opt.idEmployee !== employee.id
      );
      updatedFindEmployees.push(employee);
      
      updatedArrScales = updatedArrScales.filter(scale => 
        !scale.employeeId || scale.employeeId !== employee.id
      );
      updatedAddressesMarkers = updatedAddressesMarkers.filter(marker => 
        !(marker.typeAddress === TypeAddress.ARRAY_SCALES && marker.employeeId === employee.id)
      );
    } else if (!existingEmployee) {
      const id = updatedEmployeesSelected.length !== 0
        ? updatedEmployeesSelected[updatedEmployeesSelected.length - 1].id + 1
        : 0;
  
      const newEmployee = {
        id: id,
        idEmployee: employee.id,
        addresses: employee.addresses,
        available_trips: employee.available_trips,
        is_individual_trip: isSingleUnitForMe,
        identifier: employee.identifier,
        name: employee.name,
        depot: employee.depot,
        phone: employee.phone,
        cost_center: employee.cost_center,
        cost_center_id: employee.cost_center?.id || "",
        cost_center_name: employee.cost_center?.name || "",
        address: employee.addresses.length === 1 ? employee.addresses[0] : {},
        dropoff: { destination: true },
        isAutoAdded: isAutomaticSelection
      };
      
      if (isAutomaticSelection) {
        setAutoAddedEmployeeId(employee.id);
      }
      
      updatedEmployeesSelected.push(newEmployee);
  
      const shouldAddAsScale = !(selectedServiceOption?.value === "TheServiceIsForSomeoneElse" && 
                               updatedEmployeesSelected.length === 1 && 
                               !isSingleUnitForMe);
  
      if (employee.addresses.length > 0 && !isSingleUnitForMe && shouldAddAsScale) {
        const address = employee.addresses[0].address;
        const scaleId = updatedArrScales.length > 0 
          ? Math.max(...updatedArrScales.map(s => s.id)) + 1 
          : 3;
  
        const newScale = {
          id: scaleId,
          description: address.description,
          location: {
            lat: address.location.lat,
            lng: address.location.lon || address.location.lng,
          },
          dragg: true,
          typeAddress: TypeAddress.ARRAY_SCALES,
          employeeId: employee.id,
          employeeName: employee.name,
          stopover: true,
        };
        
        updatedArrScales.push(newScale);
        updatedAddressesMarkers.push({
          ...newScale,
          id: `scale-${scaleId}`,
          typeAddress: TypeAddress.ARRAY_SCALES,
          location: newScale.location,
        });
  
        if (employee.addresses.length === 1 && typeService.value === BookingType.ARRIVAL) {
          updatedValidationsAddresses.push(employee.addresses[0]);
        }
      }
  
      updatedFindEmployees = updatedFindEmployees.filter(
        (emp) => emp.id !== employee.id
      );
    }
  
    setArrScales(updatedArrScales);
    setAddressesMarkers(updatedAddressesMarkers);
    setValidationsAddresses(updatedValidationsAddresses);
    setEmployeesSelected(updatedEmployeesSelected);
    setEmployeesSelectedFind(updatedEmployeesSelected);
    setFindEmployees(updatedFindEmployees);
    setHasEmployeeScale(true);
  
    if (selectedOrigin && selectedDestiny) {
      setTimeout(() => {
        calculateRoute(selectedOrigin, selectedDestiny, updatedArrScales);
      }, 100);
    }
  };

  const onChangeCompany = (e) => {
    setEmployeesSelectedFind([]);
    setEmployeesSelected([]);
    setSearchResults([]);
    setShowDropdown(false);
    setSearchQuery("");
    setFilteredEmployees([]);
    setSelectedOption(null);
    setEmployeeNumber("");
    
    setShowNextBlock(false);
    setShowSelect(false);
    setSelectedServiceOption(null);
    setSelectedUnitOption(null);
    
    setShowCompany(false);
    setShowDateHour(true);
    setErrors((prevErrors) => ({ ...prevErrors, company: false }));
    
    if (!isFirstCompanySelection) {
        setOriginAddressService({});
        setDestinyAddressService({});
        setAddressesMarkers([]);
        setSelectedOrigin(null);
        setSelectedDestiny(null);
        setKey(prev => prev + 1);
    }
    
    setCompany(e);
    
    setShowGeneral(true);
    setShowTypeService(false);
    setShowAddresses(false);
    setShowUnits(false);
    setShowIdTag(false);
    setShowEmployees(false);
    setShowScales(false);
    
    setIsFirstCompanySelection(false);
  };
  
  const onChangeTypeService = (e) => {
    setShowTypeService(false);
    setShowAddresses(false);
    setShowDateHour(true);
    setTypeService(e);
    setOriginAddressService({});
    setDestinyAddressService({});
    setUnits(1);
    setAddressesMarkers([]);
    setError('typeService', false);
  };

  const handleValidateTypeService = () => {
    if (!typeService.value) {
      setError('typeService', true);
    }
  };

  const fillCompany = () => {
    setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
  };
  
  const fillTypeService = () => {
    const arr = [
      { 
        id: "DESAFORO",
        label: i18n.t("Desaforo"), 
        value: "DESAFORO",
        metaValue: BookingType.CLOSED
      },
      { 
        id: "AFORO",
        label: i18n.t("Aforo"), 
        value: "AFORO",
        metaValue: BookingType.CLOSED 
      },
    ];
  
    setListTypeService(arr);
  
    if (!typeService.value) {
      setTypeService(arr[1]);
    }
  };

  const onChangeDate = (e) => {
    const selectedDate = e[0];
    if (selectedDate) {
      setDateService(`${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`);
      setError('date', false);
    } else {
      setError('date', true);
    }
  };

  const handleHourChange = (selectedOption) => {
    const selectedHour = selectedOption?.value || "";
    setHourService(selectedHour);
  
    if (overnightHours.includes(selectedHour)) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const tomorrowStr = `${tomorrow.getFullYear()}-${(tomorrow.getMonth() + 1).toString().padStart(2, '0')}-${tomorrow.getDate().toString().padStart(2, '0')}`;
      setDateService(tomorrowStr);
    } else {
      const today = new Date();
      const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
      setDateService(todayStr);
    }
  
    if (selectedHour) {
      dropDownHidde(true, VisibilityTypes.ADDRESSES);
      validateAddresses();
    }
  };

  const dropDownHidde = (val, type) => {
    setShowCompany(type === VisibilityTypes.COMPANY ? true : false)
    setShowGeneral(type === VisibilityTypes.GENERAL ? true : false)
    setShowDateHour(type === VisibilityTypes.DATE_HOUR ? true : false)
    setShowAdditionalNote(type === VisibilityTypes.ADDITIONAL_NOTE ? true : false)
    setShowTypeService(type === VisibilityTypes.TYPE_SERVICE ? true : false)
    setShowAddresses(type === VisibilityTypes.ADDRESSES ? true : false)
    setShowUnits(type === VisibilityTypes.UNITS ? true : false)
    setShowIdTag(type === VisibilityTypes.IDTAG ? true: false)
    setShowEmployees(type === VisibilityTypes.EMPLOYEES ? true : false)
    setShowScales(type === VisibilityTypes.SCALES ? true : false)
  };
  
  const validateAddresses = useCallback(() => {
    setErrors(prev => ({
      ...prev,
      origin: typeService.value !== BookingType.ARRIVAL && !originAddressService.description,
      destiny: typeService.value === BookingType.CLOSED && !destinyAddressService.description
    }));
  }, [typeService.value, originAddressService.description, destinyAddressService.description]);

  const handleSearch = (value) => {
    setSearchQuery(value);
    
    if (value.trim() === "") {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }
  
    if (value.trim().length < 3) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }
  
    setLoading(true);
    setShowDropdown(true);
  
    const params = {
      status: "ACTIVE",
      partner_id: company.value,
      identifier: value
    };
  
    getEmployeesAdmin(token, params)
      .then((response) => {
        setSearchResults(response.items.slice(0, 5));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error searching employees:", error);
        setSearchResults([]);
        setLoading(false);
      });
  };
  
  const handleEmployeeSelect = (employee) => {
    const displayValue = [
      employee.name, 
      employee.email, 
      employee.identifier, 
      employee.phone
    ].find(value => value && value.trim() !== "");
    
    setSearchQuery(displayValue || "");
    
    if (!employee.name && !employee.email && !employee.identifier && !employee.phone) {
      console.error("The employee does not have sufficient data");
      setErrorAlertMessage(i18n.t("IncompleteEmployeeData"));
      setErrorAlert(true);
      return;
    }
  
    const hasAddresses = employee.addresses && employee.addresses.length > 0;
    const hasMultipleAddresses = hasAddresses && employee.addresses.length > 1;
    setEmployeeAddresses(employee.addresses || []);
    setEmployeeHasMultipleAddresses(hasMultipleAddresses);
    
    const completeEmployee = {
      ...employee,
      identifier: employee.identifier || "N/A",
      email: employee.email,
      phone: employee.phone,
      cost_center: employee.cost_center || { name: "N/A" }
    };
  
    setFilteredEmployees([completeEmployee]);
    setShowDropdown(false);
    
    setEmployeeNumber(completeEmployee.identifier);
    setSelectedOption({ value: "Employee", label: "Employee" });

    if (hasAddresses) {
      const primaryAddress = employee.addresses[0].address;
      
      if (primaryAddress && primaryAddress.description && primaryAddress.location) {
        const employeeDestinyAddress = {
          description: primaryAddress.description,
          location: {
            lat: primaryAddress.location.lat,
            lng: primaryAddress.location.lon || primaryAddress.location.lng
          },
          typeAddress: TypeAddress.DESTINY,
          dragg: true
        };
  
        setDestinyAddressService(employeeDestinyAddress);
        setSelectedDestiny(employeeDestinyAddress.location);
        
        const updatedMarkers = addressesMarkers.filter(marker => 
          marker.typeAddress !== TypeAddress.DESTINY
        );
        
        updatedMarkers.push({
          ...employeeDestinyAddress,
          id: TypeAddress.DESTINY
        });
        
        setAddressesMarkers(updatedMarkers);
  
        if (originAddressService?.location) {
          setTimeout(() => {
            calculateRoute(originAddressService.location, employeeDestinyAddress.location, arrScales);
          }, 100);
        }
      }
    }
  };

  const handleEmployeeAddressChange = (selectedOption) => {
    if (selectedOption) {
      const selectedAddress = {
        description: selectedOption.label,
        location: selectedOption.location,
        typeAddress: TypeAddress.DESTINY,
        dragg: true
      };
  
      setDestinyAddressService(selectedAddress);
      setSelectedDestiny(selectedOption.location);
      setErrors(prev => ({...prev, destiny: false}));
  
      const updatedMarkers = addressesMarkers.filter(marker => 
        marker.typeAddress !== TypeAddress.DESTINY
      );
      
      updatedMarkers.push({
        ...selectedAddress,
        id: TypeAddress.DESTINY
      });
      
      setAddressesMarkers(updatedMarkers);
  
      if (originAddressService?.location) {
        setTimeout(() => {
          calculateRoute(originAddressService.location, selectedOption.location, arrScales);
        }, 100);
      }
    } else {
      if (employeeAddresses.length > 0) {
        const firstAddress = employeeAddresses[0];
        const primaryAddress = firstAddress.address;
        
        const defaultAddress = {
          description: primaryAddress.description,
          location: {
            lat: primaryAddress.location.lat,
            lng: primaryAddress.location.lon || primaryAddress.location.lng
          },
          typeAddress: TypeAddress.DESTINY,
          dragg: true
        };
        
        setDestinyAddressService(defaultAddress);
        setSelectedDestiny(defaultAddress.location);
      } else {
        setDestinyAddressService({});
        setSelectedDestiny(null);
      }
    }
  };

  const formatEmployeeAddresses = useMemo(() => {
    if (!employeeAddresses || employeeAddresses.length === 0) {
      return [];
    }
    
    return employeeAddresses.map((addressItem, index) => {
      const addressDescription = addressItem.address?.description || 
                               `${i18n.t("Address")} ${index + 1}`;
      
      return {
        value: addressItem.id,
        label: addressDescription,
        description: addressDescription,
        location: {
          lat: addressItem.address?.location?.lat,
          lng: addressItem.address?.location?.lon || addressItem.address?.location?.lng
        }
      };
    });
  }, [employeeAddresses, i18n]);

  const findSelectedEmployeeAddress = useMemo(() => {
    if (!employeeAddresses.length || !destinyAddressService.description) {
      return null;
    }
    
    return formatEmployeeAddresses.find(address => 
      address.label === destinyAddressService.description
    ) || formatEmployeeAddresses[0];
  }, [employeeAddresses, destinyAddressService, formatEmployeeAddresses]);

  const serviceCreate = async (formData) => {
    return new Promise((resolve, reject) => {
        postPreRequestService(token, formData)
            .then((response) => {
                if (response.uuid) {
                    setServiceCode(response.uuid);
                    setErrorAlert(false);
                    setShowSuccessPopup(true);
                    
                    setTimeout(() => {
                        resetForm();
                        history("/services/pre-request/create");
                        resolve(response);
                    }, 3000);
                } else {
                    reject(new Error("No UUID in response"));
                }
            })
            .catch((error) => {
                console.error("Error - postPreRequestService ", error);
                setErrorAlert(true);
                setErrorAlertMessage(
                    JSON.stringify(error?.response?.data?.detail || error.message)
                );
                if (error.code == 500) {
                    setErrorAlertMessage(i18n.t("ServerError"));
                }
                reject(error);
            });
    });
  };

  const serviceEdit = async (patchPayload) => {
    try {
      const response = await patchUpdateRequest(token, id, patchPayload);
  
      if (response.code) {
        setErrorAlert(false);
        localStorage.setItem("notify", "true");
        localStorage.setItem("headerText", i18n.t("UpdatedService"));
        localStorage.setItem("bodyText", i18n.t("SuccessUpdatedService"));
  
        const redirectPath = infoUser?.is_staff
          ? "/services/general"
          : "/services/request";
  
        history(redirectPath);
      }
    } catch (error) {
      console.error("Error - patchUpdateRequest:", error);
      setErrorAlert(true);
      setErrorAlertMessage(
        JSON.stringify(error?.response?.data?.detail || error.message)
      );
  
      if (error.code === 500) {
        setErrorAlertMessage(i18n.t("ServerError"));
      }
    }
  };

  const isDisabled = useMemo(() => {
    const hasNoEmployeesOrUnits = employeesSelectedFind.length === 0 && (!units || units < 2);
    const hasNoOrigin = !originAddressService?.location;
    const hasNoDestiny = !destinyAddressService?.location;
    const shouldValidateIdTag = isPartnerAllowed(company.value || infoUser?.partner_id);
    const hasNoIdTag = shouldValidateIdTag && (!idTag || idTag.trim() === '');
  
    if (typeService.value === BookingType.OPEN) {
      return hasNoOrigin || hasNoEmployeesOrUnits || hasNoIdTag;
    }
  
    return hasNoOrigin || hasNoDestiny || hasNoEmployeesOrUnits || hasNoIdTag;
  }, [typeService.value, originAddressService?.location, destinyAddressService?.location, employeesSelectedFind, units, company.value, infoUser?.partner_id, idTag]);

  useEffect(() => {
    validateAddresses();
  }, [originAddressService, destinyAddressService, validateAddresses]);

  const resetForm = () => {
    setTypeService({ id: "DESAFORO", label: i18n.t("Desaforo"), value: "DESAFORO", metaValue: BookingType.CLOSED });
    setOriginAddressService({});
    setDestinyAddressService({});
    setAddressesMarkers([]);
    setSelectedOrigin(null);
    setSelectedDestiny(null);
    setDateService(() => {
      const today = new Date();
      return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    });
    setHourService("");
    setAditionalNote("");
    setIdTag("");
    setEmployeeNumber("");
    setSearchQuery("");
    setFilteredEmployees([]);
    setSelectedOption(null);
    setEmployeeConfirmed(false);
    setShowNextBlock(false);
    setEmployeesSelectedFind([]);
    setEmployeesSelected([]);
    setArrScales([{ id: 3, latLon: false, typeAddress: TypeAddress.ARRAY_SCALES, dragg: false, editRow: false, onDrag: false, passenger_id: null, name: null, address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } }]);
    if (infoUser.is_staff) {
      setShowCompany(true);
      setShowGeneral(false);
    } else {
      setShowCompany(false);
      setShowGeneral(true);
    }
    setShowDateHour(false);
    setShowAddresses(false);
    setKey(prev => prev + 1);
    isSubmittingRef.current = false;
    setIsSubmitting(false);
  };

  const checkDeadline = () => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const isPast7PM = currentHour > 19 || (currentHour === 19 && currentMinute > 45);
    
    setIsPastDeadline(isPast7PM);
    
    if (isPast7PM) {
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("ServiceCreationClosed"));
      return true;
    }
    return false;
  };

  const renderDeadlineMessage = () => {
    if (isPastDeadline && !isEditMode) {
      return (
        <div className="alert alert-warning mt-3" role="alert">
          <div className="d-flex align-items-center">
            <i className="bx bx-time me-2 fs-4"></i>
            <div>
              <h5 className="alert-heading mb-1">{i18n.t("ServiceCreationClosedTitle")}</h5>
              <p className="mb-0">{i18n.t("ServiceCreationClosedMessage")}</p>
              <small className="text-muted">
                {i18n.t("ServiceCreationClosedTime", { time: "7:45 PM" })}
              </small>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink title={i18n.t("Services")} link='/services/request' breadcrumbItem={i18n.t("ServiceRequest")} />
          {renderDeadlineMessage()}
          <div className="container-fluid">
            <Card>
              <Row className="p-3">
                <Col xxl={showEmployees ? 12 : 6} md={showEmployees ? 12 : 6} xs={12} className="">
                  {(!showEmployees && infoUser.is_staff) && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showCompany, VisibilityTypes.COMPANY)} 
                      >
                        <h6 className="request-create-title">
                          { `${i18n.t("Partner")} ${company.label ? `(${company.label})` : ""} ` }
                          <i className={ `${showCompany ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">{i18n.t("SelectCompanyService")}</p>
                      {showCompany && (
                        <Card className="custom-select-card">
                          <Select
                            name="company"
                            placeholder={i18n.t("SelectCompany")}
                            value={listCompanies.filter((c) => c.value == company.value)}
                            options={listCompanies}
                            className="select2-selection"
                            onChange={(e) => {
                              onChangeCompany(e);
                              dropDownHidde(true, VisibilityTypes.GENERAL);
                            }}
                            isDisabled={isEditMode || (isPastDeadline && !isEditMode)}
                          />
                          {errors.company && (
                            <span className="error-message">
                              <i className="fa fa-exclamation-circle" />
                              {i18n.t("CompanyError")}
                            </span>
                          )}
                        </Card>
                      )}
                    </Col>
                  )}
                  {(!isEditMode && !showEmployees && infoUser.is_staff) && <hr />}
                  {(!showEmployees && !isEditMode) && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showGeneral, VisibilityTypes.GENERAL)} 
                      >
                        <h6 className="request-create-title">
                          {i18n.t("General")}
                          <i className={ `${showGeneral ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">{i18n.t("EnterEmployeeIdentifier")}</p>
                      {showGeneral && (
                        <Card className="custom-select-card">
                          <div className="search-container">
                            <Input
                              className={`input-employee-data ${employeeConfirmed ? "hidden-input" : ""}`}
                              value={searchQuery}
                              placeholder={i18n.t("SearchEmployeeNumber")}
                              onChange={(e) => handleSearch(e.target.value)}
                              onFocus={() => searchQuery && setShowDropdown(true)}
                              onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                              disabled={!company.value || (isPastDeadline && !isEditMode)}
                            />
                            {showDropdown && company.value && (
                              <div className="search-dropdown">
                                {searchResults.length > 0 ? (
                                  searchResults.map((employee, index) => (
                                    <div 
                                      key={index}
                                      className="dropdown-item"
                                      onClick={() => handleEmployeeSelect(employee)}
                                    >
                                      <div>
                                        <strong>{employee.name}</strong>
                                        <div className="text-muted small">
                                          {employee.identifier && `ID: ${employee.identifier}`}
                                          {employee.email && ` | Email: ${employee.email}`}
                                          {employee.phone && ` | Tel: ${employee.phone}`}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  infoUser.is_staff && (
                                    <Link 
                                      to="/employees/create" 
                                      className="dropdown-item add-employee-link"
                                      onClick={() => {
                                        sessionStorage.setItem('selectedCompany', JSON.stringify({
                                          value: company.value,
                                          label: company.label
                                        }));
                                        sessionStorage.setItem('employeeRedirectTo', '/services/request/create');
                                      }}
                                    >
                                      <i className="bx bx-plus add-employee-icon" />
                                      {i18n.t("AddNewEmployee")}
                                    </Link>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                          <p/>
                          {employeeNumber.trim() !== "" && selectedOption && !employeeConfirmed && (
                            <>
                              <p className="request-create-text" htmlFor="companyInput">{i18n.t("ConfirmedEmployeeInformation")}</p>
                              <div className="table-responsive pt-3">
                                <Table className="table table-responsive">
                                  <thead>
                                    <tr>
                                      <th className="bg-light">{i18n.t("NoEmployee")}</th>
                                      <th className="bg-light">{i18n.t("Name")}</th>
                                      <th className="bg-light">{i18n.t("Email")}</th>
                                      <th className="bg-light cost-center-header">{i18n.t("CostCenter")}</th>
                                      <th className="bg-light">{i18n.t("Services")}</th>
                                      <th className="bg-light">{i18n.t("Department")}</th>
                                    </tr>
                                  </thead>
                                  {isLoading ? null : (
                                    <tbody>
                                      {filteredEmployees.map((employee, key) => (
                                        <tr key={key}>
                                          <td>{employee.identifier}</td>
                                          <td>{employee.name}</td>
                                          <td>{employee.email}</td>
                                          <td>{employee.cost_center?.name || "N/A"}</td>
                                          <td>{!employee.cost_center_id || employee.available_trips === -1 ? i18n.t("NotApplicable") : employee.available_trips}</td>
                                          <td>{employee.depot || "N/A"}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  )}
                                </Table>
                                {!showSelect && (
                                  <div>
                                    <button
                                      onClick={() => {
                                        if (filteredEmployees.length > 0) {
                                          const employee = filteredEmployees[0];
                                          onClickAddEmployees(employee, true, true);
                                          setAutoAddedEmployeeId(employee.id);
                                          setArrScales(prev => prev.filter(scale => scale.employeeId !== employee.id));
                                        }
                                        setShowNextBlock(true);
                                        setEmployeeConfirmed(true);
                                        dropDownHidde(true, VisibilityTypes.DATE_HOUR);
                                      }}
                                      className="btn btn-request"
                                      disabled={
                                        filteredEmployees.length > 0 &&
                                        filteredEmployees[0].cost_center_id &&
                                        filteredEmployees[0].available_trips === 0
                                      }
                                    >
                                      {i18n.t("TheInfoIsCorrect")}
                                    </button>
                                    {filteredEmployees.length > 0 && filteredEmployees[0].cost_center_id && filteredEmployees[0].available_trips === 0 && (
                                      <span className="text-danger small d-flex align-items-center gap-1"><i className="fa fa-exclamation-circle" />{i18n.t("EmployeeHasNoAvailableServices")}</span>
                                    )}
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          {employeeConfirmed && filteredEmployees.length > 0 && (
                            <>
                              <div className="employee-confirmed-card">
                                <div className="employee-header">
                                  <div className="employee-avatar">{filteredEmployees[0].name?.charAt(0)}</div>
                                  <div>
                                    <h5 className="employee-name">{filteredEmployees[0].name}</h5>
                                    <span className="employee-email">{filteredEmployees[0].email}</span>
                                  </div>
                                  <div className="employee-check"><i className="bx bx-check-circle"></i></div>
                                </div>
                                <div className="employee-info-grid">
                                  <div className="info-item">
                                    <span>{i18n.t("NoEmployee")}</span>
                                    <strong>{filteredEmployees[0].identifier}</strong>
                                  </div>
                                  <div className="info-item">
                                    <span>{i18n.t("CostCenter")}</span>
                                    <strong>{filteredEmployees[0].cost_center?.name || "N/A"}</strong>
                                  </div>
                                  <div className="info-item">
                                    <span>{i18n.t("Services")}</span>
                                    <strong>{filteredEmployees[0].available_trips === -1 ? i18n.t("NotApplicable") : filteredEmployees[0].available_trips}</strong>
                                  </div>
                                  <div className="info-item">
                                    <span>{i18n.t("Department")}</span>
                                    <strong>{filteredEmployees[0].depot || "N/A"}</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-start mt-3">
                                <button
                                  className="btn btn-link d-flex align-items-center"
                                  style={{ color: "#495057" }}
                                  onClick={() => {
                                    setEmployeeConfirmed(false);
                                    setShowSelect(false);
                                    setShowNextBlock(false);
                                  }}
                                >
                                  <i className="bx bx-revision me-2" />
                                  <span style={{ textDecoration: "underline" }}>
                                    {i18n.t("ChangeEmployee")}
                                  </span>
                                </button>
                              </div>
                            </>
                          )}
                        </Card>
                      )}
                    </Col>
                  )}
                  {showNextBlock && (
                    <>
                      {/*
                      {!isEditMode && !showEmployees && <hr />}
                      {!showEmployees && !isEditMode && ( 
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (dateService) && dropDownHidde(!showTypeService, VisibilityTypes.TYPE_SERVICE)}
                          >
                            <h6 className="request-create-title">
                              { `${i18n.t("TypeService")} ${typeService.label ? `(${typeService.label})` : ""} ` }
                              <i className={ `${showTypeService ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("SelectTypeService")}
                          </p>
                          {showTypeService && (
                            <Card className="custom-select-card">
                              <Select
                                name="typeService"
                                placeholder={i18n.t("SelectTheTypeService")}
                                value={listTypeService.find((c) => c.id === typeService.id) || null}
                                options={listTypeService}
                                className="select2-selection"
                                onChange={(e) => onChangeTypeService(e)}
                                onBlur={handleValidateTypeService}
                              />
                              {errors.typeService && (
                                <span className="error-message">
                                  <i className="fa fa-exclamation-circle"></i>
                                  {i18n.t("TypeServiceError")}
                                </span>
                              )}
                            </Card>
                          )}
                        </Col>
                      )}
                      */}
                      {!showEmployees && <hr />}
                      {!isEditMode && !showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => company.value && dropDownHidde(!showDateHour, VisibilityTypes.DATE_HOUR)}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("DateHourService")} ${(dateService && hourService) ? `(${dateService} - ${hourService})` : ''}`}
                              <i className={ `${showDateHour ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          <p className="request-create-text">{i18n.t("SelectDateHourService")}</p>
                          {showDateHour && (
                            <Row>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Date")}</Label>
                                  <div className="custom-input">
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder={i18n.t("SelectDate")}
                                      value={dateService}
                                      onChange={(e) => onChangeDate(e)}
                                      readOnly
                                      options={{
                                        minDate: "today",
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        dateFormat: "Y-m-d",
                                        defaultDate: new Date(),
                                        clickOpens: false,
                                        allowInput: false
                                      }}
                                    />
                                    <i className="mdi mdi-calendar-outline input-icon" />
                                  </div>
                                  {errors.date && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle"></i>
                                      {i18n.t("DateError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                  <Label>{i18n.t("Hour")}</Label>
                                  <div className="custom-input">
                                    <Select
                                      name="hour"
                                      placeholder={i18n.t("SelectHour")}
                                      options={allowedHoursOptions}
                                      isClearable
                                      className="select2-selection hour-select"
                                      classNamePrefix="hour-select"
                                      value={
                                        allowedHoursOptions.find((item) => item.value === hourService) || null
                                      }
                                      onChange={handleHourChange}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          width: "100%",
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          height: "38px",
                                          paddingRight: "35px",
                                          borderRadius: "0.25rem",
                                          borderColor: "#ced4da",
                                          boxShadow: "none",
                                          "&:hover": { borderColor: "#ced4da" },
                                        }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          paddingLeft: "8px",
                                        }),
                                        indicatorsContainer: (base) => ({
                                          ...base,
                                          display: "none",
                                        }),
                                      }}
                                    />
                                    <i className="mdi mdi-clock-outline input-icon" />
                                  </div>
                                  {errors.hour && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle"></i>
                                      {i18n.t("HourError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      )}
                      {!showEmployees && <hr />}
                      {!showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => {
                              typeService.value && dropDownHidde(!showAddresses, VisibilityTypes.ADDRESSES);
                              validateAddresses();
                            }}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("Addresses")} ${(originAddressService.location || destinyAddressService.location) ? `(${i18n.t("ShowMore")})` : ""}`}
                              <i className={ `${showAddresses ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` }></i>
                            </h6>
                          </Link>
                          {!showAddresses && (
                            <p className="request-create-text" htmlFor="companyInput">
                              {i18n.t("SelectAddresses")}
                            </p>
                          )}
                          {showAddresses && (
                            <Row>
                              {typeService.value === BookingType.ARRIVAL ? null : (
                                <Col xxl={6} xl={6} xs={12} className="address-input">  
                                  <p className="request-create-text" htmlFor="companyInput">
                                  {typeService.value === BookingType.OPEN
                                    ? i18n.t("TextOpenRequestAddress")
                                    : i18n.t("TextAddressRequest")}
                                  </p>
                                  <Label className="form-label">{i18n.t("OriginAddress")}</Label>
                                  <Select
                                    name="originAddress"
                                    placeholder={i18n.t("OriginAddress")}
                                    options={predefinedOriginOptions}
                                    value={predefinedOriginOptions.find(option => 
                                      option.description === originAddressService.description
                                    ) || null}
                                    onChange={handleOriginSelect}
                                    isClearable={true}
                                    className="select2-selection"
                                    classNamePrefix="address-select"
                                    styles={{
                                      container: (base) => ({
                                        ...base,
                                        width: "100%",
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        height: "38px",
                                        borderRadius: "0.25rem",
                                        borderColor: "#CED4DA",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "#CED4DA" },
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        paddingLeft: "8px",
                                      }),
                                    }}
                                  />
                                  {errors.origin && (
                                    <div className="error-message fade-in">
                                      <i className="fa fa-exclamation-circle" />
                                      <span>{i18n.t("OriginError")}</span>
                                      <button 
                                        className="btn-close-error" 
                                        onClick={() => setErrors(prev => ({...prev, origin: false}))}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  )}
                                </Col>
                              )}
                              {(typeService.value === BookingType.OPEN) || (typeService.value === BookingType.LEAVING) ? null : (
                                <Col xxl={6} xl={6} xs={12} className="address-input">
                                  <Label className="form-label">{i18n.t("DestinyAddress")}</Label>                                  
                                  {employeeHasMultipleAddresses && filteredEmployees.length > 0 ? (
                                    <Select
                                      name="employeeDestinyAddress"
                                      placeholder={i18n.t("SelectEmployeeAddress")}
                                      options={formatEmployeeAddresses}
                                      value={findSelectedEmployeeAddress}
                                      onChange={handleEmployeeAddressChange}
                                      isClearable={false}
                                      className="select2-selection"
                                      classNamePrefix="address-select"
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          width: "100%",
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          height: "38px",
                                          borderRadius: "0.25rem",
                                          borderColor: "#CED4DA",
                                          boxShadow: "none",
                                          "&:hover": { borderColor: "#CED4DA" },
                                        }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          paddingLeft: "8px",
                                        }),
                                      }}
                                    />
                                  ) : (
                                    <div className="disabled-address-field">
                                      <Input
                                        type="text"
                                        value={destinyAddressService.description || i18n.t("PredefinedDestination")}
                                        disabled
                                        className="form-control"
                                        placeholder={i18n.t("DestinationPredefined")}
                                      />
                                    </div>
                                  )}
                                  {errors.destiny && (
                                    <div className="error-message fade-in">
                                      <i className="fa fa-exclamation-circle" />
                                      <span>{i18n.t("DestinyError")}</span>
                                      <button 
                                        className="btn-close-error" 
                                        onClick={() => setErrors(prev => ({...prev, destiny: false}))}
                                        aria-label={i18n.t("CloseError")}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  )}                                 
                                  {employeeHasMultipleAddresses && (
                                    <div className="form-text text-muted mt-1">
                                      <small>
                                        <i className="bx bx-info-circle me-1"></i>
                                        {i18n.t("SelectEmployeeAddressInfo")}
                                      </small>
                                    </div>
                                  )}
                                </Col>
                              )}
                            </Row>
                          )}
                        </Col>
                      )}
                    </>
                  )}
                </Col>
                {!showEmployees && (
                  <Col xxl={6} md={6} xs={12}>
                    <MapServices
                      key={key}
                      titleAdressArrScales={titleAdressArrScales}
                      titleAdressArrEmployees={titleAdressArrEmployees}
                      setNameTitleDestiny={setNameTitleDestiny}
                      titleAdressDestiny={titleAdressDestiny}
                      setNameTitleArrScales={setNameTitleArrScales}
                      setNameTitleEmployees={setNameTitleEmployees}
                      titleAdressOrigin={titleAdressOrigin}
                      setNameTitleOrigin={setNameTitleOrigin}
                      selectedDestiny={selectedDestiny}
                      selectedOrigin={selectedOrigin}
                      setShowUnits={setShowUnits}
                      setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                      servicesView={true}
                      setShowAddresses={setShowAddresses}
                      showAddresses={showAddresses}
                      setAddressesMarkers={setAddressesMarkers}
                      addressesMarkers={addressesMarkers}
                      selectedAddress={destinyAddressService}
                      setFindEmployees={setFindEmployees}
                      findEmployees={findEmployees}
                      setShowEmployees={setShowEmployees}
                      typeService={typeService}
                      setArrScales={setArrScales}
                      arrScales={arrScales}
                      setSelectedAddress={setDestinyAddressService}
                      selectedAddressOrigin={originAddressService}
                      setSelectedAddressOrigin={setOriginAddressService}
                      selectedAddressDestiny={destinyAddressService}
                      setSelectedAddressDestiny={setDestinyAddressService}
                      typeAddress={onFocusAddress}
                      setOnFocusAddress={setOnFocusAddress}
                      setSelectedDestiny={setSelectedDestiny}
                      setSelectedOrigin={setSelectedOrigin}
                      disabled={false}
                    />
                  </Col>
                )}
                {!showEmployees && (
                  <Col xxl={12} xl={12} xs={12} className="pt-2 d-flex">
                    <button
                      onClick={() => (isEditMode ? onClickUpdateRequest() : onClickCreateRequest())} 
                      className="btn btn-request"
                      disabled={isDisabled || isSubmitting || (isPastDeadline && !isEditMode)}
                    >
                      {i18n.t(isEditMode ? "Update" : "RequestService")}
                    </button>
                    <Link to={"/services/request"} className="btn btn-go-back mx-2">
                      {i18n.t("GoBack")}
                    </Link>
                  </Col>
                )}
              </Row>
            </Card>
          </div>
        </div>
        <AlertError
          showAlertError={errorAlert}
          setShowAlertError={setErrorAlert}
          textHeader={i18n.t("ServiceAlertError")}
          textBody={errorAlertMessage}
        />
        <PopupSuccess
          showPopupSuccess={showSuccessPopup}
          setShowPopupSuccess={setShowSuccessPopup}
          textHeader={i18n.t("SuccessRequest")}
          textBody={i18n.t("ServiceCreatedSuccessfully")}
        />
      </div>
    </Fragment>
  );
};

export default PreRequestService;
